import type { PipelineState } from '@pin/schemas/admin';
import {
  defer,
  NEVER,
  Observable,
  repeat,
  Subject,
  switchMap,
  takeUntil,
  takeWhile,
} from 'rxjs';
import { isVisible$ } from '../utils/rxjs.dom';
import { retryWithBackoff } from '../utils/rxjs.http';
import { getPipelineStatus } from './pipeline';

export const createPipelinePoller = (
  participantId: string,
  stop$: Subject<void>
): Observable<PipelineState> =>
  isVisible$.pipe(
    switchMap((visible) =>
      visible
        ? defer(() => getPipelineStatus(participantId)).pipe(
            retryWithBackoff(2),
            repeat({ delay: 1000 })
          )
        : NEVER
    ),
    takeWhile(
      (state) => state.status !== 'completed' && state.status !== 'failed',
      true
    ),
    takeUntil(stop$)
  );
